interface Props {
  activeColor: string;
  bgColor?: string;
}

const SummaryIcon = ({ activeColor, bgColor }: Props) => {
  const bgFillColor = bgColor ? bgColor : "#e3e9fc";

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill="#EEF2FF" />
      <rect x="14" y="12" width="20" height="24" rx="4" fill="#234cfc" />
      <rect x="18" y="18" width="12" height="2.5" rx="1.25" fill="white" />
      <rect x="18" y="23" width="12" height="2.5" rx="1.25" fill="white" />
      <rect x="18" y="28" width="8" height="2.5" rx="1.25" fill="white" />
    </svg>
  );
};

export default SummaryIcon;
